import { Base } from './base';

export class CourseStatus extends Base {
	protected data = [
    {
      id : -1,
      name: 'すべて',
    },
    {
      id : 1,
      name: '作成中',
    },
    {
      id : 2,
      name: '配信前',
    },
    {
      id : 3,
      name: '配信中',
    },
    {
      id : 4,
      name: '最終配信済み',
    },
    {
      id : 5,
      name: '終了',
    },  
    {
      id : 6,
      name: '配信停止',
    }
  ];
}


// WEBPACK FOOTER //
// ./src/app/services/Enums/courseStatus.ts